app.controller('BrowseLayoutTabController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.tab_model = $rootScope.factory.tab.getModel($scope.navigation_ids);

    function requireChildState() {
        $rootScope.navigation_manager.requireChildState("tab");
    }

    requireChildState();

    $scope.$on('browse_navigation_state_change', function () {
        requireChildState();
    });

}])